import React from "react";
import Logo from "../images/logo.png";

export default function Loader() {
  return (
    <div className="loader-container">
      <img className="logo" src={Logo} alt="logo" />
    </div>
  );
}